//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isMobile, BUS } from "../../tools/tools.js";

export default {
  name: "MasterLogin",
  data() {
    return {
      userInfo: null,
      openLogin: false,
      isRegister: false, // 初始化时是否显示为注册
      redirectUri: "files/home", // 微信登录重定向地址
      actionPosition: "", // login_page   登录注册页 community  社区 cial_website 官网
      fromWebsiteBtns: '',
      actionDetail: {
        // 埋点参数
        login_popout_load: "", // 登陆弹框加载位置    - header_login （顶部登录按钮）、 header_register （顶部注册按钮）、 mainscreen_register （首屏注册按钮）、 hover_register （悬浮注册按钮）、 lastscreen_register （尾屏注册按钮）
        click_lanhuoauthbtn: "login_popout", // 蓝湖登录按钮点击位置 - mainscreen_register （首屏注册按钮）、 login_popout
        wechat_qr_load: "", // 微信二维码加载 - mainscreen_register （首屏注册按钮）、 login_popout
      },
      disableOptions:{
        lanhu: false,
        thirdPartLogin: false,
        wechat: false,
        dingding: false,
        google: true,
        linkedin: true,
        twitter: true,
        wecom: true,
      }
    };
  },
  inject: ["loginConfig", "plugin", "judgeJump", "mobileRedirectUri"],
  computed: {
    MLoginOpen() {
      if (
        process.client &&
        sessionStorage.getItem("websiteUserState") === "true" &&
        this.openLogin
      ) {
        if(this.fromWebsiteBtns) {
          location.href = `/files/home?open_version_dialog=true&version_type=${this.fromWebsiteBtns}`;
        } else {
          location.href = `/files/home`;
        }
        this.openLogin = false;
      }
      if (this.openLogin && isMobile()) {
        // 移动端跳转
        let redirectUri = ''; 
        if (this.mobileRedirectUri) {
          redirectUri = this.mobileRedirectUri(); // 返回一个url
          if (redirectUri)
            redirectUri = `?redirect=${redirectUri}`
        }
        location.href = `/login${redirectUri}`;
        this.openLogin = false;
      }
      if (!this.openLogin) {
        this.isDialog = true;
        this.loginType = "static";
      }
      return this.openLogin;
    },
  },
  methods: {
    setloginConfig(options) {
      let datas = null;
      if (options) {
        datas = options;
      } else if (this.loginConfig) {
        datas = this.loginConfig;
      } else {
        return;
      }
      Object.keys(datas).forEach((key) => {
        this[key] = datas[key];
      });
    },
    toastHandle() {
      BUS.emit("MLogin", {
        type: "toast",
        datas: arguments,
      });
    },
    closeHandle() {
      // 关闭
      this.openLogin = false;
      this.isRegister = false;
      BUS.emit("MLogin", {
        type: "close",
        datas: arguments,
      });
    },
    setUserInfoHandle(userdatas, isJump) {
      // 登录成功，设置用户信息
      const flag = isJump ? isJump : false;
      this.loginSuccess(userdatas, flag, 'setUserInfo');
      BUS.emit("MLogin", {
        type: "setUserInfo",
        datas: arguments,
      });
    },
    async loginSuccess(userdatas, flag, type) {
      //官网 登陆成功 from 满足跳转条件
      this.userInfo = userdatas;
      // 登陆成功， 用户头像切换
      BUS.emit("setUserInfo", userdatas);
      if (process.client) {
        if (!flag) {
          if (type === 'setUserInfo' && (!this.judgeJump || this.judgeJump())) { // 判断是否要跳转
            if (this.fromWebsiteBtns) {
              location.href = `${location.origin}/files/home?open_version_dialog=true&version_type=${this.fromWebsiteBtns}`;
            } else {
              location.href = `${location.origin}/files/home`;
            }
          }
          this.closeHandle();
        }
        sessionStorage.setItem("websiteUserState", true);
      }
    },
    turnPageHandle(path) {
      // 路由跳转
      BUS.emit("MLogin", {
        type: "turnPage",
        datas: arguments,
      });
      if (window && location) {
        location.href = `${location.origin}${path}`;
      }
    },
    showLogin() {
      // 打开登陆
      this.openLogin = true;
      this.isRegister = false;
    },
    showRegister() {
      // 打开注册
      this.openLogin = true;
      this.isRegister = true;
    },
    autoLogin() {
      this.plugin?.login()
        .then((res) => {
          if (res.data) {
            this.loginSuccess(res.data, false, 'autoLogin');
          } else {
            BUS.emit("setUserInfo", null);
            if (process.client) {
              sessionStorage.setItem("websiteUserState", false);
            }
          }
        })
        .catch((error) => {
          BUS.emit("setUserInfo", null);
          if (process.client) {
            sessionStorage.setItem("websiteUserState", false);
          }
        });
    },
  },
  mounted() {
    BUS.on("openLogin", (datas) => {
      const { openLogin, isRegister, options } = datas;
      this.setloginConfig(options);
      this.openLogin = openLogin;
      this.isRegister = isRegister;
    });
    this.setloginConfig();
    this.autoLogin();
  },
  destroyed() {
    BUS.off("openLogin");
  },
};
